import { userType } from 'reactApp/appHelpers/configHelpers';
import { sendDwh } from 'reactApp/utils/ga';

export const createBoardShow = () => {
    sendDwh({
        eventCategory: 'dropdown-create-board-show',
        dwh_enabled: true,
        dwhData: {
            user_type: userType,
        },
    });
};
